// @lib-export
var InfiniteLoaderPositionData;
(function (InfiniteLoaderPositionData) {
    InfiniteLoaderPositionData["END"] = "END";
    InfiniteLoaderPositionData["MIDDLE"] = "MIDDLE";
    InfiniteLoaderPositionData["START"] = "START";
})(InfiniteLoaderPositionData || (InfiniteLoaderPositionData = {}));

export { InfiniteLoaderPositionData };
//# sourceMappingURL=infinite-loader-position-data.js.map
